import React, { useMemo } from 'react';
import { MAPPED_BADGE_TYPE, BADGE_TYPE } from './rewardsConstants.js';
import PeerToPeerBadge from './PeerToPeerBadge/PeerToPeerBadge.jsx';
import AutomateBadge from './Automate/AutomateBadge.jsx';
import NeoBadge from './BadgeIcon/NeoBadge.jsx';

const CoreBadge = (props) => {
	const {
		label,
		companyName,
		captureId,
		useTilt = true,
		hideSnappyIcon = true,
		shape,
		customImageSignedUrl,
	} = props;
	const breakWords = useMemo(() => {
		if (label && label.length > 15) {
			const words = label.split(' ');
			let line1 = '';
			let line2 = '';
			for (const word of words) {
				if (line1.length + word.length + 1 <= 15) {
					line1 += word + ' ';
				} else {
					line2 += word + ' ';
				}
			}
			return [line1, line2].filter((line) => line.trim().length > 0);
		} else {
			return [label || ''];
		}
	}, [label]);

	switch (props.badgeType) {
		case BADGE_TYPE.PEERTOPEER:
		case BADGE_TYPE.NOMINATED:
		case MAPPED_BADGE_TYPE.PEERTOPEER:
		case MAPPED_BADGE_TYPE.NOMINATED:
			return (
				<PeerToPeerBadge
					hideSnappyIcon={hideSnappyIcon}
					useTilt={useTilt}
					captureId={captureId}
					breakWords={breakWords}
					snappyDetails={props.snappyDetails}
					{...props}
				/>
			);
		case BADGE_TYPE.AUTOMATED:
		case MAPPED_BADGE_TYPE.AUTOMATED:
			if (shape === 'custom' && customImageSignedUrl) {
				return (
					<NeoBadge
						captureId={captureId}
						customImage={customImageSignedUrl}
						useTilt={useTilt}
					/>
				);
			}

			return (
				<AutomateBadge
					captureId={captureId}
					companyName={companyName}
					breakWords={breakWords}
					{...props}
				/>
			);
		default:
			return <></>;
	}
};

export default CoreBadge;
